import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, User, CalendarDays } from "lucide-react";
import { projects } from "../mock";
import { SectionLabel, Reveal } from "../components/common";

export const ProjectCard = ({ p }) => (
  <div className="group relative overflow-hidden rounded-lg">
    <img
      src={p.img}
      alt={p.title}
      className="w-full h-[360px] object-cover transition-transform duration-700 group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B102D]/90 via-transparent to-transparent" />
    <span className="absolute top-5 left-5 bg-[#CD0008] text-white text-xs font-display font-semibold uppercase tracking-wide px-3 py-1.5 rounded-sm">
      {p.category}
    </span>
    <div className="absolute left-5 right-5 bottom-5 translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
      <div className="bg-white rounded-lg p-5 flex items-center justify-between gap-4">
        <div>
          <h3 className="font-display font-bold text-[#0B102D] text-lg leading-tight">{p.title}</h3>
          <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-xs text-gray-500">
            <span className="flex items-center gap-1"><User size={13} className="text-[#CD0008]" /> {p.client}</span>
            <span className="flex items-center gap-1"><CalendarDays size={13} className="text-[#CD0008]" /> {p.date}</span>
          </div>
        </div>
        <span className="w-11 h-11 shrink-0 flex items-center justify-center bg-[#CD0008] text-white rounded-md">
          <ArrowUpRight size={20} />
        </span>
      </div>
    </div>
  </div>
);

const Projects = () => {
  return (
    <section className="py-24 bg-[#F1F3F7]">
      <div className="max-w-[1320px] mx-auto px-5">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <SectionLabel>Recent Projects</SectionLabel>
            <h2 className="section-heading text-[#0B102D] text-4xl md:text-5xl">
              A selection of our recent work
            </h2>
          </div>
          <Link
            to="/projects"
            className="inline-flex items-center gap-2 font-display font-semibold uppercase tracking-wide text-sm text-[#0B102D] hover:text-[#CD0008] transition-colors"
          >
            View All Projects <ArrowUpRight size={18} />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {projects.map((p, i) => (
            <Reveal key={p.id} direction="up" delay={(i % 3) * 120}>
              <ProjectCard p={p} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
